const getUsername = (loginCredentialsData) => loginCredentialsData.get('u');
const getPassword = (loginCredentialsData) => loginCredentialsData.get('p');

export {
	getUsername,
	getPassword
}